<template>
  <div class="concept">
    <div id="head-page" class="illuFilRouge parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/globulo-filrouge.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/stars-filrouge.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/pierre-filrouge.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-8 medium-offset-2 cell">

          <div v-if="currentUser.account_type === 'child'">
            <title-page attrpage="Prochainement" baseline="Pars à la conquête de ta guérison !">Jeu Fil Rouge</title-page>

            <p>C’est un jeu avec plusieurs niveaux qui va t’accompagner pendant ton traitement et qui t’aidera à passer le temps pendant certains soins à l’hôpital. Tu peux bien sûr y jouer aussi chez toi autant que tu le veux.</p>
            <p>Tu pourras y jouer avec d’autres personnes qui constitueront ta Communauté. Pour cela, demande à tes parents de créer un compte Globulo Quest à tes frères et sœurs, cousins, copains d’école ou qui tu veux et défie-les en comparant vos scores !</p>
            <p>Le jeu Fil Rouge est en cours de développement actuellement.</p>

          </div>

          <div v-if="currentUser.account_type === 'parent'">
            <title-page attrpage="Prochainement" :baseline=" 'Partez à la conquête de la guérison de '+ childName">Jeu Fil Rouge</title-page>

            <p>C’est un jeu avec plusieurs niveaux qui va accompagner {{ childName }} pendant son traitement et qui l’aidera à passer le temps pendant certains soins à l’hôpital. {{ childName }} peut jouer à la maison ou à l'hôpital, le jeu l'accompagne partout.</p>
            <p>{{ childName }} pourra y jouer avec d’autres personnes qui constitueront sa Communauté. Pour cela, vous pouvez créer un compte Globulo Quest à ses frères et sœurs, cousins ou copains d’école.</p>
            <p>Le jeu Fil Rouge est en cours de développement actuellement.</p>

          </div>

          <div v-if="currentUser.account_type === 'relative'">
            <title-page attrpage="Prochainement" :baseline=" 'Partez à la conquête de la guérison de '+ childName">Jeu Fil Rouge</title-page>

            <p>C’est un jeu avec plusieurs niveaux qui va accompagner {{ childName }} pendant son traitement et qui l’aidera à passer le temps pendant certains soins à l’hôpital. {{ childName }} peut jouer à la maison ou à l'hôpital, le jeu l'accompagne partout.</p>
            <p>{{ childName }} pourras y jouer avec d’autres personnes qui constitueront sa Communauté (ses frères et sœurs, cousins ou copains d’école).</p>
            <p>Le jeu Fil Rouge est en cours de développement actuellement.</p>

          </div>

          <div class="center">
            <img src="@/assets/images/content/landing-fil-rouge.jpg" alt="Jeu Fil Rouge" title="Jeu Fil Rouge"/>
          </div>

          <div class="small-12 medium-3 medium-offset-3 cell">
            <h5>Je veux être informé dès la sortie du jeu Fil Rouge</h5>
            <p v-if="thx">Votre message a bien été envoyé. Nous vous recontacterons dès que possible.</p>
            <div v-else class="form filrouge">
              <div class="line">
                <div :class="{error: errors.indexOf('lastname') !== -1}">
                  <label for="nom">Nom*</label>
                  <input type="text" name="nom" id="nom" v-model="lastname" />
                </div>
                <div :class="{error: errors.indexOf('firstname') !== -1}">
                  <label for="prenom">Prénom*</label>
                  <input type="text" name="prenom" id="prenom" v-model="firstname" />
                </div>
                <div :class="{error: errors.indexOf('email') !== -1}">
                  <label for="email">Email*</label>
                  <input type="email" name="email" id="email" required  v-model="email"/>
                </div>
                <input class="button btnPush" name="submit" type="submit" @mouseover="verify" @click="send" value="Tenez-moi informé(e)" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapGetters } from 'vuex'

  import TitlePage from '@/components/TitlePage'
  export default {
    components: { TitlePage },
    computed: {
      ...mapGetters(['childName']),
      currentUser() {
        return this.$store.state.me
      },
    },
    data() {
      return {
        firstname: '',
        lastname: '',
        email: '',
        errors: [],
        thx: false
      }
    },
    methods: {
      ...mapActions(['sendFilRouge']),
      verify (field) {
        this.errors = []
        if (!this.firstname) {
          this.errors.push("firstname")
        }
        if (!this.lastname) {
          this.errors.push("lastname")
        }
        if (!this.email) {
          this.errors.push("email")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          this.sendFilRouge({ firstname: this.firstname, lastname: this.lastname, email: this.email }),
          this.thx = true
        } catch(ex) {
          throw ex;
        }
      }
    }
  }
</script>
